"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _slicedToArray2 = require("babel-runtime/helpers/slicedToArray");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _idbReactTranslations = require("@identitybuilding/idb-react-translations");

var _idbReactTranslations2 = _interopRequireDefault(_idbReactTranslations);

var _idbReactUiElements = require("@identitybuilding/idb-react-ui-elements");

var _axios = require("axios");

var _axios2 = _interopRequireDefault(_axios);

var _idbReactIconlib = require("@identitybuilding/idb-react-iconlib");

var _idbReactIconlib2 = _interopRequireDefault(_idbReactIconlib);

var _mijnStadGemeente_fr = require("../images/mijn.stad-gemeente_fr.svg");

var _mijnStadGemeente_fr2 = _interopRequireDefault(_mijnStadGemeente_fr);

var _mijnStadGemeente_nl = require("../images/mijn.stad-gemeente_nl.svg");

var _mijnStadGemeente_nl2 = _interopRequireDefault(_mijnStadGemeente_nl);

var _Dropdownlist = require("../components/Dropdownlist.js");

var _Dropdownlist2 = _interopRequireDefault(_Dropdownlist);

var _pn_blue = require("../images/pn_blue.png");

var _pn_blue2 = _interopRequireDefault(_pn_blue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pinBlueIcon = "";


var Sidebar = function Sidebar(props) {
  var _useState = (0, _react.useState)(""),
      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
      suggestions = _useState2[0],
      setSuggestions = _useState2[1];

  var _useState3 = (0, _react.useState)(0),
      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
      typingTimeout = _useState4[0],
      setTypingTimeout = _useState4[1];

  var _useState5 = (0, _react.useState)(""),
      _useState6 = (0, _slicedToArray3.default)(_useState5, 2),
      searchValue = _useState6[0],
      setSearchValue = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = (0, _slicedToArray3.default)(_useState7, 2),
      visibleText = _useState8[0],
      setVisibleText = _useState8[1];

  var translate = function translate(e) {
    return (0, _idbReactTranslations2.default)(e, props.lang);
  };
  var CancelToken = _axios2.default.CancelToken;
  var source = CancelToken.source();

  var _useState9 = (0, _react.useState)(false),
      _useState10 = (0, _slicedToArray3.default)(_useState9, 2),
      modalOpen = _useState10[0],
      setModalOpen = _useState10[1];

  var searchNis = function searchNis(e) {
    setSuggestions("");
    if (typingTimeout) clearTimeout(typingTimeout);
    setTimeout((0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              source.cancel();

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, undefined);
    })), 1000);
    var value = "";
    if (e) {
      setSearchValue(e.target.value);
      // value = e.target.value.replace('La ', '');
      value = e.target.value;
      if (/^\d+$/.test(value)) {
        value += " ";
      }
    }

    setTypingTimeout(setTimeout(function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(e) {
        var as_model, stringFields, numberFields, post_filter, option, data, _suggestions;

        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                as_model = require("../models/index.js").default;
                stringFields = ["name_nl", "name_fr", "name_de", "name_en", "alt_name_nl", "alt_name_fr", "submunicipality_set.alt_name_fr", "submunicipality_set.alt_name_nl", "submunicipality_set.name_nl", "submunicipality_set.name_fr", "submunicipality_set.name_de", "submunicipality_set.name_en", "nis_code", "nis_code_1970", "nis_code_1977", "submunicipality_set.nis_code_1970", "submunicipality_set.nis_code_1977"];
                numberFields = ["pkancode", "pkancode.keyword", "nis_code", "nis_code_1970", "nis_code_1977", "submunicipality_set.pkancode", "submunicipality_set.nis_code_1970", "submunicipality_set.nis_code_1977"];
                post_filter = props.type === 'vlaanderen' ? {
                  "bool": {
                    "should": [{
                      "term": {
                        "region.nis_code": "4000"
                      }
                    }, {
                      "term": {
                        "region.nis_code": "2000"
                      }
                    }]
                  }
                } : {
                  "bool": {
                    "should": [{
                      "term": {
                        "region.nis_code": "4000"
                      }
                    }, {
                      "term": {
                        "region.nis_code": "3000"
                      }
                    }, {
                      "term": {
                        "region.nis_code": "2000"
                      }
                    }]
                  }
                };
                option = {};

                if (value) {
                  option = {
                    from: 0,
                    size: 581,
                    query: {
                      bool: {
                        should: [{
                          query_string: {
                            query: "\"" + value + "\"",

                            fields: stringFields,
                            tie_breaker: 0.3
                          }
                        }, {
                          query_string: {
                            query: "*" + value + " *",

                            fields: stringFields,
                            tie_breaker: 0.3
                          }
                        }, {
                          query_string: {
                            query: "" + value,

                            fields: stringFields,
                            tie_breaker: 0.3
                          }
                        }]
                      }

                    },
                    sort: [
                      // {
                      //   pkancode: {
                      //     order: "asc",
                      //   },
                      // },
                    ]
                    // post_filter: post_filter
                  };
                } else {
                  option = {
                    size: 581,
                    query: {
                      bool: {
                        should: [{ match_phrase: { "pkancode": value } }, { match_phrase: { "pkancode.keyword": value } }, { match_phrase: { "submunicipality_set.pkancode": value } }, { match_phrase: { "submunicipality_set.pkancode.keyword": value } }, { term: { "nis_code": value } }, { term: { "nis_code_1970": value } }, { term: { "nis_code_1977": value } }],
                        minimum_should_match: 1 // Ensures at least one match

                      }
                    },
                    sort: [{
                      "pkancode.keyword": {
                        "order": "asc",
                        "unmapped_type": "keyword" // Prevent errors if field is missing
                      }
                    }],

                    post_filter: post_filter
                  };
                }

                if (!value) {
                  _context2.next = 12;
                  break;
                }

                data = [];
                _context2.next = 10;
                return _axios2.default.post("https://elasticsearch.100procentlokaal.be/municipalities/_search", (0, _stringify2.default)(option), {
                  auth: {
                    username: "ashish",
                    password: "QWi7RhJmByGuVmmnZng4"
                  },
                  headers: {
                    "Content-Type": "application/json"
                  }
                }).then(function (res) {
                  data = as_model(res.data.hits.hits, props.lang, translate, value, props.MyCity);
                  return data;
                }).catch(function (error) {
                  console.log(error);
                });

              case 10:
                _suggestions = _context2.sent;

                if (_suggestions && _suggestions.length > 0) {
                  setSuggestions(_suggestions);
                }

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, undefined);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }(), 500));
  };

  (0, _react.useEffect)(function () {
    var mapDrawer = document.querySelector(".mapDrawer");
    if (modalOpen) {
      mapDrawer.classList.add("blurred");
    } else {
      mapDrawer.classList.remove("blurred");
    }
  }, [modalOpen]);

  var openUrl = function openUrl(e, i) {
    if (!e || !e.name) return;
    // let name = e.name;
    var name = e.name.replace(/\s+/g, '-').toLowerCase();

    // .replace('â', 'a')
    //   .replace(" (stad)", "")
    //   .replace(" (ville)", "")
    //   .replace(" (stadt)", "")
    //   .replace(" city", "")
    //   .replace(/\ /g, "")
    //   .replace("'", "");
    if (name === "sgravenbrakel") name = "s-gravenbrakel";
    if (name === "Mont-de-lEnclus") name = "montdelenclus";
    if (name === "LesBonsVillers") name = "les-bons-villers";

    var parent = e.parent ? e.parent.replace(" (stad)", "").replace(" (ville)", "").replace(" (stadt)", "").replace(" city", "").replace(/\ /g, "").replace("'", "") : "";

    if (parent === "sgravenbrakel") parent = "s-gravenbrakel";
    if (parent === "Mont-de-lEnclus") parent = "montdelenclus";
    if (parent === "LesBonsVillers") parent = "les-bons-villers";

    if (e.parent_slug && e.type === "municipality") {
      parent = e.parent_slug.toLowerCase();
    }

    var url = "";
    // else if (e.parent_slug) {
    //     await axios.get(`https://api.ondernemersnetwerk.be/location/nis/by-name/${e.parent_slug}`)
    //         .then((res) => {
    //             let as_model = require(`../models/index.js`).default;
    //             let data = as_model(res.data, props.lang, translate)
    //             parent = data[0].name.toLowerCase()
    //         })
    // }

    // if (e.type === 'submunicipality') { window.open(`https://${parent.replace('-1', '').replace('-2', '')}.${props.baseUrl}`) }
    // else if (e.parent_slug && e.type === 'municipality') { window.open(`https://${parent.replace('-1', '').replace('-2', '')}.${props.baseUrl}`) }
    // else { window.open(`https://${name.replace('-1', '').replace('-2', '')}.${props.baseUrl}`) }
    // Redirect based on postal code
    if (e.postal_code === "9100" || e.postal_code === "9111" || e.postal_code === "9112") {
      url = "https://sint-niklaas." + props.baseUrl;
    }
    // Redirect municipality and submunicipality
    else if (e.type === "submunicipality") {
        url = "https://" + e.postal_code + "." + props.baseUrl;
      } else if (e.parent_slug && e.type === "municipality") {
        url = "https://" + parent + "." + props.baseUrl;
      } else {
        url = "https://" + name + "." + props.baseUrl;
      }
    // all postcodes of the submunicipalities redirects to the municipality site
    // return `https://${e.postal_code}.${props.baseUrl}`;
    // Ensure URL only opens on user click
    if (e && e.name) {
      window.open(url, "_blank");
    }
  };

  var _useState11 = (0, _react.useState)(window.innerWidth <= 500),
      _useState12 = (0, _slicedToArray3.default)(_useState11, 2),
      isMobile = _useState12[0],
      setIsMobile = _useState12[1];

  (0, _react.useEffect)(function () {
    var handleResize = function handleResize() {
      setIsMobile(window.innerWidth <= 500);
    };

    window.addEventListener("resize", handleResize);
    return function () {
      return window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Initialize navigate for redirection

  var handleLogout = function handleLogout() {
    localStorage.removeItem("StadGemeenteToken"); // Remove auth token
    localStorage.removeItem("isLoggedIn"); // Remove auth token
    localStorage.removeItem("followState"); // Remove auth token

    if (props.lang === 'nl' ? window.location.href = "https://mijn.stad-gemeente.be" : window.location.href = "https://ma.ville-commune.be") ;
  };

  return _react2.default.createElement(
    "div",
    { className: "mapDrawer " + (props.MyCity ? "MyCity" : "") + "  " + (props.className ? props.className : "") },
    props.MyCity ? _react2.default.createElement(
      "div",
      { className: "mapDrawerTop info city" },
      _react2.default.createElement("img", {
        id: "procentLogo",
        className: "city",
        src: "https://zappa-tlaqv351d.s3.amazonaws.com/media/brand/l/mijn_stad-gemeente.png",
        alt: "Logo of 100% lokaal"
      }),
      props.lang === 'nl' ?
      // <div className="cityLogo" dangerouslySetInnerHTML={{ __html: StadGemeente }} />
      _react2.default.createElement("img", {
        className: "cityLogo",
        src: "https://o-sn.be/kml/stad-gemeente_nl.svg",
        alt: "Logo of 100% lokaal"
      }) :
      // <div className="cityLogo" dangerouslySetInnerHTML={{ __html: VilleCommune }} />
      _react2.default.createElement("img", {
        className: "cityLogo",
        src: "https://o-sn.be/kml/stad-gemeente_fr.svg",
        alt: "Logo of 100% lokaal"
      })
    ) : _react2.default.createElement(
      "div",
      { className: "mapDrawerTop info" },
      _react2.default.createElement("img", {
        id: "procentLogo",
        src: require("../images/" + (props.lang === "nl" ? "logo.png" : "logo_fr.png")),
        alt: "Logo of 100% lokaal"
      }),
      !props.MyCity && _react2.default.createElement(
        "span",
        { style: {
            position: "absolute",
            bottom: "5px",
            fontSize: "13px",
            left: "50%",
            transform: "translate(-50%)",
            whiteSpace: "nowrap",
            fontWeight: "600",
            color: "var(--grey-90)",
            textShadow: "0 0 black"
          } },
        translate("in_colaberation_with")
      )
    ),
    _react2.default.createElement(
      "div",
      {
        style: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          fontSize: "12px",
          marginBottom: "10px"
        }
      },
      props.MyCity ? _react2.default.createElement(
        "div",
        null,
        window.innerWidth > 500 ? props.lang === "nl" ? "Zoek een stad / gemeente of selecteer op kaart" : _react2.default.createElement(
          "span",
          null,
          "Recherchez une ville / commune ",
          _react2.default.createElement("br", null),
          " ou s\xE9lectionnez sur la carte"
        ) : props.lang === "nl" ? "Zoek een stad / gemeente of provincie" : "Recherchez une ville / commune ou province"
      ) : null
    ),
    _react2.default.createElement(
      "div",
      { className: "searchbar_wrapper" },
      _react2.default.createElement(
        "div",
        { className: "searchbar" },
        _react2.default.createElement(_idbReactUiElements.OsnInputText, {
          className: "searchMunicipality " + (window.location.href.includes("mijn.stad-gemeente.be") || window.location.href.includes("ma.ville-commune.be") || props.MyCity === true ? "blueBorder" : "blackBorder"),
          label: translate("search"),
          icon: "Search",
          placeholder: translate("search"),
          template: 1
          // onKeyDown={() =>
          //   setTimeout(() => {
          //     searchNis();
          //   }, 500)
          // }
          , onChange: function onChange(e) {
            return searchNis(e);
          },
          close: true
        }),
        props.MyCity ? _react2.default.createElement(_idbReactUiElements.OsnSelect, {
          active: props.lang.toUpperCase(),
          options: [{ id: 1, name: "NL" }, { id: 2, name: "FR" }],
          onChange: function onChange(e) {
            return e.name === "NL" ? window.location.href = 'https://mijn.stad-gemeente.be' : window.location.href = "https://ma.ville-commune.be";
          }
        }) : _react2.default.createElement(_idbReactUiElements.OsnSelect, {
          active: window.location.hostname === "www.100procentlokaal.be" || window.location.hostname === "vlaanderen.100procentlokaal.be" ? "NL" : "FR",
          options: [{ id: 1, name: "NL" }, { id: 2, name: "FR" }],
          onChange: function onChange(e) {
            if (props.type === 'vlaanderen') {
              e.name === "NL" ? window.location.href = 'https://vlaanderen.100procentlokaal.be' : window.location.href = "https://flandre.100pourcentlocale.be";
            } else {
              e.name === "NL" ? window.location.href = 'https://www.100procentlokaal.be' : window.location.href = "https://www.100pourcentlocale.be";
            }
          }
        })
      ),
      _react2.default.createElement(
        "div",
        null,
        searchValue && suggestions && suggestions.length > 0 ? _react2.default.createElement(
          "div",
          { className: "auto_suggestion_wrapper" },
          suggestions.map(function (res, index) {
            return props.getData ? _react2.default.createElement(
              "a",
              {
                key: index,
                className: "auto_suggestion " + res.type + " " + (window.location.href.includes("mijn.stad-gemeente.be") || window.location.href.includes("ma.ville-commune.be") || props.MyCity === true ? "auto_suggestion_stad_gemeente" : "auto_suggestion_100procentlokaal"),
                onClick: function onClick() {
                  return props.getData(res);
                }
              },
              _react2.default.createElement(
                "span",
                null,
                res.text
              )
            ) :
            // <a
            //   key={index}
            //   className={`auto_suggestion ${res.type}`}
            //   href={openUrl(res, index)}
            //   rel="nofollow noopener noreferrer"
            //   target="_blank"
            // >
            //   <span>{res.text}</span>
            // </a>
            _react2.default.createElement(
              "a",
              {
                key: index,
                className: "auto_suggestion " + res.type,
                onClick: function onClick() {
                  return openUrl(res);
                }
              },
              _react2.default.createElement(
                "span",
                null,
                res.text
              )
            );
          })
        ) : _react2.default.createElement(
          "div",
          null,
          !props.MyCity ? props.lang === "nl" ? _react2.default.createElement(
            "span",
            { style: {
                display: "flex",
                width: "57%",
                margin: "0 auto",
                marginTop: "4%",
                fontSize: "14px"
              } },
            "Zoek een stad / gemeente of selecteer op kaart"
          ) : _react2.default.createElement(
            "span",
            { style: {
                display: "flex",
                width: "71%",
                margin: "0 auto",
                marginTop: "4%",
                fontSize: "14px"
              } },
            "Recherchez une ville / commune ou s\xE9lectionnez sur la carte"
          ) : null
        )
      )
    ),
    props.MyCity && props.MyCity === true ? _react2.default.createElement(
      "div",
      { className: "MyCity_text" },
      _react2.default.createElement(
        "div",
        null,
        props.loggedIn === false ? _react2.default.createElement(
          _react2.default.Fragment,
          null,
          _react2.default.createElement(
            "h6",
            {
              style: {
                display: window.innerWidth <= 500 ? "none" : undefined,
                textShadow: "0 0 var(--cn)",
                letterSpacing: "0.5px",
                color: "var(--cn)",
                fontFamily: "'Open Sans', sans-serif",
                fontWeight: "bolder",
                margin: "1.5cm 6% 0% 6%",
                fontSize: "13px"
              }
            },
            translate("sidebar_inform_text")
          ),
          _react2.default.createElement(
            "p",
            { style: { display: window.innerWidth <= 500 ? "none" : undefined } },
            _react2.default.createElement(
              "b",
              null,
              translate("sidebar_text_1")
            )
          ),
          _react2.default.createElement(
            "p",
            { style: { display: window.innerWidth <= 500 ? "none" : undefined } },
            props.lang === "nl" ? _react2.default.createElement(
              "span",
              null,
              _react2.default.createElement("img", { src: _pn_blue2.default, style: { height: "12px", width: "12px" }, alt: "icon" }),
              "\xA0",
              _react2.default.createElement(
                "span",
                { style: { color: 'var(--cn)' } },
                "Actieve publicaties: "
              ),
              "Steden en gemeenten die hun infoblad online publiceren, worden aangeduid met een blauw vlak. Met een persoonlijk account ontvang je een e-mailmelding zodra er een nieuwe publicatie beschikbaar is."
            ) : _react2.default.createElement(
              "span",
              null,
              _react2.default.createElement("img", { src: _pn_blue2.default, style: { height: "12px", width: "12px" }, alt: "icon" }),
              "\xA0",
              _react2.default.createElement(
                "span",
                { style: { color: 'var(--cn)' } },
                "Publications actives: "
              ),
              "Les villes et communes qui publient leur bulletin en ligne sont indiqu\xE9es par un encadr\xE9 bleu. Avec un compte personnel, vous recevez une notification par e-mail d\xE8s qu'une nouvelle publication est disponible."
            )
          ),
          _react2.default.createElement(
            "p",
            { style: { display: window.innerWidth <= 500 ? "none" : undefined } },
            props.lang === "nl" ? _react2.default.createElement(
              "span",
              null,
              _react2.default.createElement("img", { src: _pn_blue2.default, style: { height: "12px", width: "12px" }, alt: "icon" }),
              "\xA0",
              _react2.default.createElement(
                "span",
                { style: { color: 'var(--cn)' } },
                "Volgen van andere gemeenten: "
              ),
              "Wil je steden of gemeenten volgen die nog niet publiceren? Duid ze aan als favoriet en bij registratie ontvangen zij automatisch jouw verzoek per e-mail."
            ) : _react2.default.createElement(
              "span",
              null,
              _react2.default.createElement("img", { src: _pn_blue2.default, style: { height: "12px", width: "12px" }, alt: "icon" }),
              "\xA0",
              _react2.default.createElement(
                "span",
                { style: { color: 'var(--cn)' } },
                "Suivi d\u2019autres communes: "
              ),
              "Vous souhaitez suivre des villes ou communes qui ne publient pas encore ? S\xE9lectionnez-les comme favoris et, lors de votre inscription, elles recevront automatiquement votre demande par e-mail."
            )
          ),
          _react2.default.createElement(
            "p",
            { style: { display: window.innerWidth <= 500 ? "none" : undefined } },
            props.lang === "nl" ? _react2.default.createElement(
              "span",
              null,
              _react2.default.createElement("img", { src: _pn_blue2.default, style: { height: "12px", width: "12px" }, alt: "icon" }),
              "\xA0",
              _react2.default.createElement(
                "span",
                { style: { color: 'var(--cn)' } },
                "Persoonlijk overzicht: "
              ),
              "Na registratie krijg je een gepersonaliseerd overzicht van de steden en gemeenten die je volgt."
            ) : _react2.default.createElement(
              "span",
              null,
              _react2.default.createElement("img", { src: _pn_blue2.default, style: { height: "12px", width: "12px" }, alt: "icon" }),
              "\xA0",
              _react2.default.createElement(
                "span",
                { style: { color: 'var(--cn)' } },
                "Vue personnalis\xE9e : "
              ),
              "Apr\xE8s votre inscription, vous b\xE9n\xE9ficiez d\u2019un aper\xE7u personnalis\xE9 des villes et communes que vous suivez."
            )
          )
        ) : props.lang === "nl" ? _react2.default.createElement(
          _react2.default.Fragment,
          null,
          _react2.default.createElement(
            "div",
            null,
            _react2.default.createElement(
              "p",
              {
                style: {
                  display: window.innerWidth <= 500 ? "none" : undefined,
                  textShadow: "0 0 var(--cn)",
                  letterSpacing: "0.5px",
                  marginTop: "1.5cm",
                  color: "var(--cn)",
                  fontFamily: "'Open Sans', sans-serif",
                  fontWeight: "bolder",
                  fontSize: "13px"
                }
              },
              "Kies jouw overzicht"
            ),
            _react2.default.createElement(
              "p",
              { style: { display: window.innerWidth <= 500 ? "none" : undefined } },
              "Als geregistreerde en aangemelde gebruiker kan je eenvoudig schakelen tussen:"
            ),
            _react2.default.createElement(
              "p",
              { style: { display: window.innerWidth <= 500 ? "none" : undefined } },
              _react2.default.createElement("img", { src: _pn_blue2.default, style: { height: "12px", width: "12px" }, alt: "icon" }),
              "\xA0",
              _react2.default.createElement(
                "span",
                { style: { color: 'var(--cn)' } },
                "ACTIEVE GEMEENTEN: "
              ),
              "Steden en gemeenten die hun infoblad online publiceren, worden aangeduid met een blauw vlak."
            ),
            _react2.default.createElement(
              "p",
              { style: { display: window.innerWidth <= 500 ? "none" : undefined } },
              _react2.default.createElement("img", { src: _pn_blue2.default, style: { height: "12px", width: "12px" }, alt: "icon" }),
              "\xA0",
              _react2.default.createElement(
                "span",
                { style: { color: 'var(--cn)' } },
                "WIE VOLG IK: "
              ),
              "Hier zie je een gepersonaliseerd overzicht van de steden en gemeenten die je volgt. Je kan altijd extra steden en gemeenten toevoegen aan je favorieten. Zij ontvangen dan automatisch jouw verzoek per e-mail."
            )
          )
        ) : _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(
            "p",
            {
              style: {
                display: window.innerWidth <= 500 ? "none" : undefined,
                textShadow: "0 0 var(--cn)",
                letterSpacing: "0.5px",
                marginTop: "1.5cm",
                color: "var(--cn)",
                fontFamily: "'Open Sans', sans-serif",
                fontWeight: "bolder",
                fontSize: "13px"
              }
            },
            "Choisissez votre aper\xE7u"
          ),
          _react2.default.createElement(
            "p",
            { style: { display: window.innerWidth <= 500 ? "none" : undefined } },
            "En tant qu'utilisateur inscrit et connect\xE9, vous pouvez facilement basculer entre :"
          ),
          _react2.default.createElement(
            "p",
            { style: { display: window.innerWidth <= 500 ? "none" : undefined } },
            _react2.default.createElement("img", { src: _pn_blue2.default, style: { height: "12px", width: "12px" }, alt: "icon" }),
            "\xA0",
            _react2.default.createElement(
              "span",
              { style: { color: 'var(--cn)' } },
              "COMMUNES ACTIVES:"
            ),
            " Les villes et communes qui publient leur bulletin en ligne sont indiqu\xE9es par un encadr\xE9 bleu."
          ),
          _react2.default.createElement(
            "p",
            { style: { display: window.innerWidth <= 500 ? "none" : undefined } },
            _react2.default.createElement("img", { src: _pn_blue2.default, style: { height: "12px", width: "12px" }, alt: "icon" }),
            "\xA0",
            _react2.default.createElement(
              "span",
              { style: { color: 'var(--cn)' } },
              "MES SUIVIS:"
            ),
            " Retrouvez ici un aper\xE7u personnalis\xE9 des villes et communes que vous suivez. Vous pouvez toujours ajouter d'autres villes et communes \xE0 vos favoris. Elles recevront alors automatiquement votre demande par e-mail:"
          )
        ),
        _react2.default.createElement(
          "div",
          null,
          props.MyCity && isMobile && _react2.default.createElement(
            "div",
            null,
            _react2.default.createElement(
              "p",
              {
                style: {
                  fontSize: "9px",
                  textAlign: "center",
                  lineHeight: "1.5",
                  margin: "0 auto 15px",
                  maxWidth: "400px"
                }
              },
              translate("sidebar_infotext_1")
            ),
            _react2.default.createElement(
              "p",
              {
                style: {
                  fontSize: "9px",
                  textAlign: "center",
                  lineHeight: "1.5",
                  margin: "0 auto 15px",
                  maxWidth: "400px"
                }
              },
              translate("sidebar_infotext_2")
            ),
            _react2.default.createElement(
              "div",
              {
                className: "ddlist",
                style: {
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "15px"
                }
              },
              _react2.default.createElement(_Dropdownlist2.default, {
                className: "ddlist1",
                placeholder: translate("dropdown_list_1"),
                options: props.hasCollaborationMunicipalityNames,
                lang: props.lang
              }),
              props.loggedIn && _react2.default.createElement(_Dropdownlist2.default, {
                className: "ddlist2",
                placeholder: translate("dropdown_list_2"),
                options: props.followingMunicipalitiesNames
              })
            )
          )
        ),
        _react2.default.createElement("span", { className: "p" }),
        _react2.default.createElement("br", null)
      ),
      _react2.default.createElement(
        "div",
        { className: "button_wrapper",
          style: { bottom: isMobile ? "7%" : "3%" } },
        props.loggedIn && isMobile && _react2.default.createElement(_idbReactUiElements.Button, {
          borderColor: "cn",
          text: translate("log_out"),
          txtColor: "cn",
          type: "sub",
          size: "S",
          onClick: handleLogout
        }),
        !props.loggedIn && _react2.default.createElement(_idbReactUiElements.Button, {
          borderColor: "cn",
          text: translate("log_in"),
          txtColor: "cn",
          type: "sub",
          size: "S",
          onClick: function onClick(e) {
            setModalOpen(true);
            props.login(e);
          }
        }),
        _react2.default.createElement(_idbReactUiElements.Button, {
          borderColor: "cn",
          text: props.lang === "nl" ? "Ga naar 100% Lokaal" : "VISITEZ 100% LOCAL",
          txtColor: "cn",
          type: "sub",
          size: "S",
          url: props.lang === "nl" ? "https://www.100procentlokaal.be/" : "https://www.100pourcentlocale.be/"
        })
      )
    ) : _react2.default.createElement(
      "div",
      { style: { display: "flex", flexDirection: "column" } },
      _react2.default.createElement(
        "video",
        { className: "video", autoPlay: true, controls: true, muted: true },
        props.type === 'vlaanderen' ? _react2.default.createElement("source", {
          src: "https://o-sn.be/seg/vlaanderen.100procentlokaal.be%20-%20voor-steden-en-gemeenten.mp4",
          type: "video/mp4"
        }) : _react2.default.createElement("source", {
          src: props.lang === 'nl' ? "https://o-sn.be/seg/www.100procentlokaal.be%20-%20voor-steden-en-gemeenten.mp4" : "https://o-sn.be/seg/100pourcentlocal.be-pour-villes-et-communes.mp4",
          type: "video/mp4"
        })
      ),
      _react2.default.createElement(
        "div",
        { className: "mapOptions" },
        _react2.default.createElement(
          "h2",
          null,
          translate("borders")
        ),
        props.type === 'vlaanderen' ? props.borders.filter(function (border) {
          return border.name !== 'regions';
        }).map(function (border, index) {
          return _react2.default.createElement(_idbReactUiElements.OsnCheckbox, {
            key: index,
            checked: border.active,
            name: translate(border.name),
            onChange: function onChange() {
              return props.checkboxHandler(border, props.type === 'vlaanderen' ? index + 1 : index);
            },
            value: translate(border.name),
            className: border.name
          });
        }) : props.borders.map(function (border, index) {
          return _react2.default.createElement(_idbReactUiElements.OsnCheckbox, {
            key: index,
            checked: border.active,
            name: translate(border.name),
            onChange: function onChange() {
              return props.checkboxHandler(border, index);
            },
            value: translate(border.name),
            className: border.name
          });
        })
      ),
      _react2.default.createElement(
        "div",
        { className: "mapOptions" },
        _react2.default.createElement(_idbReactUiElements.OsnCheckbox, {
          checked: props.baseLayer,
          name: translate("map"),
          onChange: function onChange() {
            return props.setBaseLayer(!props.baseLayer);
          },
          value: translate("map")
        }),
        _react2.default.createElement(_idbReactUiElements.OsnCheckbox, {
          checked: props.baseNames,
          name: translate("municipality_names"),
          onChange: function onChange() {
            return props.setBaseNames(!props.baseNames);
          },
          value: translate("municipality_names")
        })
      ),
      _react2.default.createElement("div", { id: "custom-map-controls" })
    )
  );
};

exports.default = Sidebar;